/* Local catalogue interpretation, following ADP's explicit constraints and unresolved-word pattern. */
(function (host) {
  'use strict';
  const normalize = (value) => String(value || '').normalize('NFKC').toLowerCase().replace(/[–—]/g, '-').replace(/[’‘]/g, "'").replace(/\s+/g, ' ').trim();
  const stop = new Set('i a an the would like want need please looking for my our this that it is be to have with in of at on and or but only not no without exclude avoid do does should can could you me us something anything basin basins sink sinks bowl bowls ceramic ceramics about approximately around preferably prefer find show model models mm'.split(' '));
  const rules = [
    ['category','wudu_basin',/\b(?:wudu|wudhu|woodu)(?:[ -]basins?)?\b|小净盆|净身盆|洗手洗脚一体盆/g],
    ['tap_hole','none',/\b(?:no|without|zero|0)\s+(?:any |a )?tap[ -]?holes?\b|无龙头孔|无孔|不要龙头孔/g],
    ['tap_hole','one',/\b(?:one|1|single)\s+tap[ -]?holes?\b|单孔|一个龙头孔/g],
    ['tap_hole','two',/\b(?:two|2)\s+tap[ -]?holes?\b|双孔/g],
    ['tap_hole','three',/\b(?:three|3)\s+tap[ -]?holes?\b|三孔/g],
    ['overflow','no',/\b(?:no|without)\s+(?:an? )?overflow(?:\s+hole)?\b|无溢水孔|不要溢水孔/g],
    ['overflow','yes',/\b(?:with|has|include|including)\s+(?:an? )?overflow(?:\s+hole)?\b|有溢水孔|带溢水孔/g],
    ['shape','rectangular',/\b(?:rectangle|rectangular|oblong)\b|长方形|长方/g],
    ['shape','square',/\bsquare\b|正方形|方形/g],
    ['shape','oval',/\b(?:oval|elliptical)\b|椭圆形|椭圆/g],
    ['shape','semi_round',/\bsemi[ -]?round\b|\bd[ -]?shaped\b|半圆(?:形)?(?:盆)?/g],
    ['shape','corner',/\bcorner(?:[ -]basins?)?\b|转角(?:盆)?|角盆/g],
    ['shape','irregular',/\b(?:irregular|asymmetric|asymmetrical)\b|不规则(?:形)?(?:盆)?|不对称/g],
    ['shape','round',/\b(?:round|circular|circle)\b|圆形|圆盆/g],
    ['mounting_type','countertop',/\b(?:counter[ -]?top|above[ -]counter|vessel|on[ -]counter)\b|台上盆|台上/g],
    ['mounting_type','undermount',/\b(?:under[ -]?mount|under[ -]counter)\b|台下盆|台下/g],
    ['mounting_type','semi_recessed',/\bsemi[ -]recessed\b|半嵌入/g],
    ['mounting_type','inset',/\b(?:inset|drop[ -]?in|recessed)\b|嵌入式|嵌入/g],
    ['mounting_type','wall_hung',/\bwall[ -]?(?:hung|mounted|mount)\b|壁挂式|壁挂/g],
    ['mounting_type','pedestal',/\b(?:pedestal|free[ -]?standing)\b|立柱盆|立柱/g]
  ];

  function parse(text, products) {
    const source = normalize(text);
    const chars = source.split('');
    const constraints = {};
    for (const [field,value,pattern] of rules) {
      pattern.lastIndex = 0;
      for (const match of source.matchAll(pattern)) {
        const start = match.index;
        const end = start + match[0].length;
        if (chars.slice(start,end).every(c => c === ' ')) continue;
        const before = source.slice(0,start).split(/[,;.，。；]|\b(?:and|but|with|or)\b/).pop();
        const negative = /(?:\b(?:not|no|without|avoid|exclude|except)\b\s*(?:a |an |any )?|不要|排除|非)\s*$/.test(before);
        const group = constraints[field] ||= { include:[], exclude:[] };
        const values = group[negative ? 'exclude' : 'include'];
        if (!values.includes(value)) values.push(value);
        for (let i=start;i<end;i++) chars[i]=' ';
      }
    }
    const remainder = chars.join('').replace(/我想要|我需要|帮我找|我要|请|洗手盆|洗脸盆|面盆|陶瓷|的|不要|排除|不是|以及|或者|和|一个|一款/g,' ');
    const words = remainder.split(/[\s,;.!?，。；！？]+/).filter(word => word && !stop.has(word));
    const modelTerms = [], unresolved = [];
    for (const word of new Set(words)) {
      if (products.some(product => normalize(product.model).includes(word))) modelTerms.push(word);
      else unresolved.push(word);
    }
    return { constraints, modelTerms, unresolved };
  }

  function search(products, input = {}) {
    const parsed = parse(input.text, products);
    const constraints = parsed.constraints;
    const overrides = [];
    for (const [field,value] of Object.entries(input.filters || {})) {
      if (!value) continue;
      if (constraints[field]) overrides.push(field);
      constraints[field] = { include:[value], exclude:[] };
    }
    const dimensions = {};
    for (const key of ['width_mm','depth_mm','height_mm']) {
      const value = Number(input.dimensions?.[key]);
      if (Number.isFinite(value) && value > 0) dimensions[key] = value;
    }
    const ranges = {};
    for (const key of ['width_mm','depth_mm']) {
      const range = input.ranges?.[key];
      if (!range || range.min == null || range.max == null || range.min === '' || range.max === '') continue;
      const min = Number(range.min), max = Number(range.max);
      if (Number.isFinite(min) && Number.isFinite(max) && min >= 0 && max >= min) ranges[key] = {min, max};
    }
    const active = Object.keys(constraints).length > 0 || Object.keys(dimensions).length > 0 || Object.keys(ranges).length > 0 || parsed.modelTerms.length > 0;
    if (!active) return { ...parsed, dimensions, ranges, overrides, active:false, items:[] };
    const matchingProducts = (allowUnverified) => products.filter(product => {
      for (const [key,{min,max}] of Object.entries(ranges)) {
        const value = Number(product[key]);
        if (!Number.isFinite(value) || value <= 0 || value < min || value > max) return false;
      }
      for (const [field,group] of Object.entries(constraints)) {
        const value = field === 'mounting_type' && product.category === 'wudu_basin' ? 'wudu_basin' : product[field];
        if (!value || value === 'unknown') {
          if (allowUnverified && (field === 'tap_hole' || field === 'overflow') && group.include.length && !group.include.includes('unknown')) continue;
          if (!group.include.includes('unknown')) return false;
        }
        if (group.include.length && !group.include.includes(value)) return false;
        if (group.exclude.includes(value)) return false;
      }
      return parsed.modelTerms.every(term => normalize(product.model).includes(term));
    });
    let matched = matchingProducts(false);
    const provisional = !matched.length && ['tap_hole', 'overflow'].some(field => constraints[field]?.include.length);
    if (provisional) matched = matchingProducts(true);
    const provisionalFields = provisional && matched.length
      ? ['tap_hole', 'overflow'].filter(field => constraints[field]?.include.length && matched.some(product => !product[field] || product[field] === 'unknown'))
      : [];
    const items = matched.map(product => {
      let distance = 0, missing = 0;
      const differences = {};
      for (const [key,target] of Object.entries(dimensions)) {
        const value = Number(product[key]);
        if (!Number.isFinite(value) || value <= 0) { missing++; differences[key] = null; }
        else { differences[key] = value - target; distance += Math.abs(value - target); }
      }
      return { product, distance, missing, differences };
    }).sort((a,b) => a.missing - b.missing || a.distance - b.distance || String(a.product.model).localeCompare(String(b.product.model), 'en', {numeric:true}) || a.product.id.localeCompare(b.product.id));
    return { ...parsed, constraints, dimensions, ranges, overrides, active, items, provisionalFields };
  }
  function sortMatches(items, order = 'best') {
    const sorted = [...items];
    if (!['height-asc', 'height-desc'].includes(order)) return sorted;
    const height = match => {
      const value = Number(match.product.height_mm);
      return Number.isFinite(value) && value > 0 ? value : null;
    };
    return sorted.sort((a, b) => {
      const first = height(a), second = height(b);
      if (first === null) return second === null ? 0 : 1;
      if (second === null) return -1;
      return order === 'height-asc' ? first - second : second - first;
    });
  }
  const api = { search, sortMatches };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else host.KFSearch = api;
})(typeof window === 'undefined' ? globalThis : window);
